import moment from 'moment'
import 'moment-timezone'
import Amplify from '@aws-amplify/core'
import {
  amplifyConfigEHRData,
  amplifyConfigData,
  amplifyConfigDataNewSetUp,
} from '../services/amplifyConfig'

const { NODE_ENV } = process.env

const log = NODE_ENV === 'development' ? console.log : () => {}
window.log = log

const getCurrentLocation = () => window.location.hash + window.location.search

export function getTimeDiffernce(oldTimestamp, newTimestamp = null) {
  const cuurentTimestamp = newTimestamp || Date.now()
  let difference = cuurentTimestamp - oldTimestamp

  const daysDifference = Math.floor(difference / 1000 / 60 / 60 / 24)
  difference -= daysDifference * 1000 * 60 * 60 * 24

  const hoursDifference = Math.floor(difference / 1000 / 60 / 60)
  difference -= hoursDifference * 1000 * 60 * 60

  const minutesDifference = Math.floor(difference / 1000 / 60)
  difference -= minutesDifference * 1000 * 60

  const secondsDifference = Math.floor(difference / 1000)

  window.log(
    `difference: day/s=${daysDifference}  hour/s=${hoursDifference} minute/s=${minutesDifference} second/s=${secondsDifference}`,
  )
  return {
    minutes: minutesDifference,
    seconds: secondsDifference,
    days: daysDifference,
    hours: hoursDifference,
  }
}

/* eslint no-else-return: "error" */
function calculateMews(data) {
  // { sp: 65, hr: 78, rr: 99, tmp: 90 }
  const calculateSP = (value) => {
    if (value <= 70) return 3
    else if (value >= 71 && value <= 80) return 2
    else if (value >= 81 && value <= 100) return 1
    else if (value >= 101 && value <= 199) return 0
    else if (value >= 200) return 2
    return 0
  }
  const calculateHR = (value) => {
    if (value <= 40) return 2
    else if (value >= 41 && value <= 50) return 1
    else if (value >= 51 && value <= 100) return 0
    else if (value >= 101 && value <= 110) return 1
    else if (value >= 111 && value <= 129) return 2
    else if (value >= 130) return 3
    return 0
  }
  const calculateRR = (value) => {
    if (value <= 9) return 2
    else if (value >= 9 && value <= 14) return 0
    else if (value >= 15 && value <= 20) return 1
    else if (value >= 21 && value <= 29) return 2
    else if (value >= 30) return 3
    return 0
  }
  const calculateTemp = (value) => {
    if (value <= 95) return 2
    else if (value >= 95 && value <= 101.1) return 0
    else if (value >= 101.2) return 2
    return 0
  }

  let total = 0
  total += calculateHR(data.hr)
  total += calculateSP(data.sp)
  total += calculateRR(data.rr)
  total += calculateTemp(data.temp)

  return total
}

const formatAbsoluteValue = (value = 0) => {
  let finalValue
  if (value > 0) {
    finalValue = `+${value.toFixed(1)}`
  } else {
    finalValue = value.toFixed(1)
  }
  return Number(finalValue) === 0 ? 0 : finalValue
}

const overrideAPIDomain = (apiConfig) => {
  if (apiConfig === 'newAPIDomain') {
    Amplify.configure(amplifyConfigDataNewSetUp)
  } else if (apiConfig === 'ehrAPIDomain') {
    Amplify.configure(amplifyConfigEHRData)
  } else {
    Amplify.configure(amplifyConfigData)
  }
  return Amplify
}

const getTimezoneOffsets = () => {
  const timeZones = moment.tz.names()
  const offsetTmz = []
  timeZones.map((item, index) =>
    offsetTmz.push({
      name: `${moment.tz(timeZones[index]).format('Z')} ${timeZones[index]}`,
      nameOnly: item,
      id: moment.tz(timeZones[index]).format('Z'),
      key: index,
    }),
  )
  return offsetTmz
}

const isDevApi = () => {
  const {
    location: { hostname },
  } = window
  return (
    // process.env.NODE_ENV === 'development' ||
    hostname.includes('s3-website-us-east-1.amazonaws.com') || hostname.includes('.cloudfront.net')
  )
}

export {
  log,
  NODE_ENV,
  getCurrentLocation,
  calculateMews,
  formatAbsoluteValue,
  overrideAPIDomain,
  getTimezoneOffsets,
  isDevApi,
}
